import { buildApiUrl } from '../helpers/buildApiUrl';
import httpService from './httpService';
const search = (data) => {
    return httpService.get(buildApiUrl('/search'), data);
};
export default {
    search,
};
